export const CODE_POINT_JOINER = "-";
export const BREAK_SPACE_CHARACTER = "\u0020";
export const NO_BREAK_SPACE_CHARACTER = "\u00A0";
